import { useEffect } from "react";

const JivoChatWidget = () => {
    useEffect(() => {
        const script = document.createElement("script");
        script.src = `//code.jivo.ru/widget/${process.env.REACT_APP_JIVOCHAT_WIDGET_ID}`;
        script.async = true;
        document.body.appendChild(script);
    }, []);

    return null;
};

export default JivoChatWidget;
